import { useObserver } from 'mobx-react-lite'
import React, { FC, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { RecoSectionContent } from '@aboutyou/legacy-tracking-sdk'
import BrandSlider from 'components/BrandSlider'
import StickyScrollToButton from 'components/StickyScrollToButton'
import { useTranslation } from 'helpers/hooks/useTranslation'
import {
  useBrandOverviewPageStore,
  useUiStore,
  useUserStore,
} from 'store/context'
import styled from 'styled-components'
import { fsM, fsXS, fwLight } from 'uiComponents/constants/typography'

const MEDIA_QUERY_SM = 'sm'
const SLIDES_TO_SHOW_DEFAULT = 2
const SLIDE_TO_SHOW_AT_MD = 3

const getSlidesToShow = (matchMedia: string) =>
  matchMedia !== MEDIA_QUERY_SM ? SLIDE_TO_SHOW_AT_MD : SLIDES_TO_SHOW_DEFAULT

const RelativeWrapper = styled.div`
  position: relative;
`

const Container = styled.div`
  margin-bottom: 52px;
`
const Subline = styled.h3`
  font-size: ${fsXS}px;
  ${fwLight}

  line-height: 1.54;
`

const Headline = styled.h2`
  font-size: ${fsM}px;
  ${fwLight}
  line-height: 1.4;
  margin-bottom: 19px;
`

export const BrandsOverviewRecommendations: FC<
  React.PropsWithChildren
> = () => {
  const wrapperRef = useRef<HTMLDivElement>(null)
  const location = useLocation()
  const { t } = useTranslation()
  const uiStore = useUiStore()
  const matchedMedia = useObserver(() => uiStore.matchedMedia)
  const gender = useUserStore(store => store.gender)
  const topBrandIdsByGender = useBrandOverviewPageStore(
    store => store.topBrandIdsByGender,
  )
  const topBrandIds = topBrandIdsByGender[gender]

  const isFilteredByPremium = Boolean(
    new URLSearchParams(location.search).get('premium'),
  )

  return (
    <RelativeWrapper className="col-sm-12" ref={wrapperRef}>
      <StickyScrollToButton toSection="brands" container={wrapperRef} />
      {topBrandIds.length > 0 && (
        <Container className="row">
          <Subline className="col-sm-12">
            {t('Derzeit bei anderen Nutzern gefragt')}
          </Subline>
          <Headline className="col-sm-12">
            {isFilteredByPremium
              ? t('Alle Premium-Marken bei ABOUT YOU')
              : t('Beliebte Marken für Dich')}
          </Headline>
          <BrandSlider
            brandIds={topBrandIds}
            slidesToScroll={1}
            slidesToShow={getSlidesToShow(matchedMedia)}
            recoType={RecoSectionContent.topBrands}
          />
        </Container>
      )}
    </RelativeWrapper>
  )
}
